import pkg from '../../../../package.json';

export const { dependencies, version } = pkg;

/**
 * Base URL for the CMS on the UNPKG CDN.
 */
export const UNPKG_BASE_URL = 'https://unpkg.com/@sveltia/cms';

/**
 * URL of the Sveltia CMS repository on GitHub.
 */
export const REPOSITORY_URL = 'https://github.com/sveltia/sveltia-cms';

/**
 * Base URL for the Sveltia CMS documentation.
 */
export const DOCS_BASE_URL = 'https://sveltiacms.app/en/docs';
